export const editableFundReportForm = {
  pretext: {
    article9: {
      en: `**Periodic disclosure for the financial products referred to in Article 9, paragraphs 1 to 4a, of Regulation (EU) 2019/2088 and Article 5, first paragraph, of Regulation (EU) 2020/852**
<br>
<br>
All information in this view is required for the periodic disclosure of
financial products falling under Article 9, paragraphs 1 to 4a of
Regulation (EU) 2019/2088 and Article 5, first paragraph, of Regulation
(EU) 2020/852. Therefore, it is essential that you carefully review that
all the information provided is accurate and complete.

<strong style="color: var(--v-primary-base)">Please carefully read the following introduction on how to use the template.</strong>

**Using the Templates:**
Our system generated texts automatically based on the data you’ve provided in the Fund Setting Module
and your portfolio companies provided in the ESG assessment.
These texts can be easily transferred to the input field by clicking on the “Replace” button.

**Reviewing and Editing the Template:**
It’s crucial to carefully review the questions and the automatically generated sentences,
and if needed, add any data that is missing to make sure all information has been included to meet the periodic disclosure requirements.

**Personalizing the Responses:**
The templates serve as guidelines. You have the flexibility to use the provided texts in their entirety,
write your own response, or combine the two approaches to complete the questionnaire.
Most of the fields can be edited to provide a more accurate or detailed response.
However, please note that some fields are locked and cannot be edited.
Regardless, a review is always necessary to ensure accuracy and completeness.
Remember, the goal is to ensure full transparency about your sustainability risks and opportunities.`,
      de: `**Periodische Offenlegung für die in Artikel 9 Absätze 1 bis 4a der Verordnung (EU) 2019/2088 und Artikel 5 Absatz 1 der Verordnung (EU) 2020/852 genannten Finanzprodukte**
<br>
<br>
Alle Informationen in dieser Ansicht sind für die periodische Offenlegung von
Finanzprodukten erforderlich, die unter Artikel 9 Absätze 1 bis 4a der
Verordnung (EU) 2019/2088 und Artikel 5 Absatz 1 der Verordnung
(EU) 2020/852 fallen. Daher ist es entscheidend, dass Sie sorgfältig prüfen,
ob alle bereitgestellten Informationen korrekt und vollständig sind.

<strong style="color: var(--v-primary-base)">Bitte lesen Sie die folgende Einführung zur Verwendung der Vorlage sorgfältig durch.</strong>

**Verwendung der Vorlagen:**
Unsere Systemtexte werden automatisch basierend auf den Daten generiert, die Sie im Modul „Fund Setting“
und im ESG-Assessment zu Ihren Portfoliounternehmen bereitgestellt haben.
Diese Texte können ganz einfach in das Eingabefeld übernommen werden, indem Sie auf die Schaltfläche „Ersetzen“ klicken.

**Überprüfung und Bearbeitung der Vorlage:**
Es ist äußerst wichtig, die Fragen und automatisch generierten Sätze sorgfältig zu prüfen
und gegebenenfalls fehlende Angaben zu ergänzen, um sicherzustellen, dass alle Informationen
enthalten sind, die für die Erfüllung der periodischen Offenlegungspflichten benötigt werden.

**Personalisierung der Antworten:**
Die Vorlagen dienen als Leitfaden. Sie können die bereitgestellten Texte vollständig verwenden,
eigene Formulierungen verfassen oder beide Ansätze kombinieren, um den Fragebogen auszufüllen.
Die meisten Felder können bearbeitet werden, um eine genauere oder detailliertere Antwort zu geben.
Beachten Sie jedoch, dass einige Felder gesperrt sind und nicht bearbeitet werden können.
Eine Überprüfung ist dennoch stets notwendig, um Richtigkeit und Vollständigkeit sicherzustellen.
Denken Sie daran, dass das Ziel eine vollständige Transparenz über Ihre Nachhaltigkeitsrisiken und -chancen ist.`,
    },
    article8: {
      en: `**Periodic disclosure for the financial products referred to in Article 8, paragraphs 1, 2 and 2a, of Regulation (EU) 2019/2088 and Article 6, first paragraph, of Regulation (EU) 2020/852**
<br>
<br>
All information in this view is required for the periodic disclosure of
financial products falling under Article 8, paragraphs 1, 2 and 2a of
Regulation (EU) 2019/2088 and Article 6, first paragraph, of Regulation
(EU) 2020/852. Therefore, it is essential that you carefully review that
all the information provided is accurate and complete.

<strong style="color: var(--v-primary-base)">Please carefully read the following introduction on how to use the template.</strong>

**Using the Templates:**
Our system generated texts automatically based on the data you’ve provided in the Fund Setting Module
and your portfolio companies provided in the ESG assessment.
These texts can be easily transferred to the input field by clicking on the “Replace” button.

**Reviewing and Editing the Template:**
It’s crucial to carefully review the questions and the automatically generated sentences,
and if needed, add any data that is missing to make sure all information has been included to meet the periodic disclosure requirements.

**Personalizing the Responses:**
The templates serve as orientation. You have the flexibility to use the provided texts in their entirety,
write your own response, or combine the two approaches to complete the questionnaire.
Most of the fields can be edited to provide a more accurate or detailed response.
However, please note that some fields are locked and cannot be edited.
Regardless, a review is always necessary to ensure accuracy and completeness.
Remember, the goal is to ensure full transparency about your sustainability risks and opportunities.`,
      de: `**Periodische Offenlegung für die in Artikel 8 Absätze 1, 2 und 2a der Verordnung (EU) 2019/2088 und Artikel 6 Absatz 1 der Verordnung (EU) 2020/852 genannten Finanzprodukte**
<br>
<br>
Alle Informationen in dieser Ansicht sind für die periodische Offenlegung von
Finanzprodukten erforderlich, die unter Artikel 8 Absätze 1, 2 und 2a der
Verordnung (EU) 2019/2088 und Artikel 6 Absatz 1 der Verordnung
(EU) 2020/852 fallen. Daher ist es unbedingt erforderlich, dass Sie sorgfältig prüfen,
ob alle bereitgestellten Informationen korrekt und vollständig sind.

<strong style="color: var(--v-primary-base)">Bitte lesen Sie die folgende Einführung zur Verwendung der Vorlage sorgfältig durch.</strong>

**Verwendung der Vorlagen:**
Unsere Systemtexte werden automatisch basierend auf den Daten generiert, die Sie im Modul „Fund Setting“
und im ESG-Assessment für Ihre Portfoliounternehmen bereitgestellt haben.
Diese Texte können leicht durch Klicken auf die Schaltfläche „Ersetzen“ in das Eingabefeld übernommen werden.

**Überprüfung und Bearbeitung der Vorlage:**
Es ist entscheidend, die Fragen und die automatisch generierten Sätze sorgfältig zu überprüfen
und gegebenenfalls fehlende Angaben zu ergänzen, um sicherzustellen, dass alle Informationen
enthalten sind, die zur Erfüllung der periodischen Offenlegungspflichten benötigt werden.

**Personalisierung der Antworten:**
Die Vorlagen dienen als Orientierung. Sie können die bereitgestellten Texte vollständig übernehmen,
eigene Formulierungen schreiben oder beides kombinieren, um den Fragebogen zu vervollständigen.
Die meisten Felder sind bearbeitbar und erlauben detailliertere Antworten.
Bitte beachten Sie jedoch, dass einige Felder gesperrt sind und nicht bearbeitet werden können.
Eine Überprüfung ist in jedem Fall notwendig, um Richtigkeit und Vollständigkeit zu gewährleisten.
Denken Sie daran, dass das Ziel die vollständige Transparenz Ihrer Nachhaltigkeitsrisiken und -chancen ist.`,
    },
  },
  fundDetails: {
    fundName: {
      en: 'What is the name of the fund?',
      de: 'Wie lautet der Name des Fonds?',
    },
    fundNameTooltip: {
      en: 'This field is populated from the Fund Setup. To make changes, update the Fund Setup module.',
      de: 'Dieses Feld wird aus dem Fonds-Setup übernommen. Änderungen nehmen Sie im Modul „Fonds-Setup“ vor.',
    },
    legalName: {
      en: 'What is the name of the entity?',
      de: 'Wie lautet der Name der juristischen Person?',
    },
    legalNameTooltip: {
      en: 'This field is populated from the Fund Setup. To make changes, update the Fund Setup module.',
      de: 'Dieses Feld wird aus dem Fonds-Setup übernommen. Änderungen nehmen Sie im Modul „Fonds-Setup“ vor.',
    },
    legalEntityIdentifier: {
      en: 'What is the legal entity identifier (LEI code) of the Fund?',
      de: 'Wie lautet der Legal Entity Identifier (LEI-Code) des Fonds?',
    },
    legalEntityIdentifierTooltip: {
      en: 'This field is populated from the Fund Setup. To make changes, update the Fund Setup module.',
      de: 'Dieses Feld wird aus dem Fonds-Setup übernommen. Änderungen nehmen Sie im Modul „Fonds-Setup“ vor.',
    },
  },
  title: {
    article8: {
      en: 'Environmental and/or social characteristics',
      de: 'Ökologische und/oder soziale Merkmale',
    },
    article8Tooltip: {
      en: `This field is populated automatically, using the details you've provided in the Fund Setting Module. Modifications cannot be made directly in this field.`,
      de: `Dieses Feld wird automatisch basierend auf den im Modul „Fund Setting“ bereitgestellten Angaben ausgefüllt. Änderungen können nicht direkt in diesem Feld vorgenommen werden.`,
    },
    article9: {
      en: 'Sustainable Investment Objective',
      de: 'Nachhaltiges Anlageziel',
    },
    article9Tooltip: {
      en: '',
      de: '',
    },
  },
}

export const editableFundReportAdditionalInfo = {
  1: {
    en: `**#1 Sustainable** covers sustainable investments with environmental or social objectives.
**#2 Not sustainable** includes investments which do not qualify as sustainable investments.`,
    de: `**#1 Nachhaltig** umfasst nachhaltige Investitionen mit ökologischen oder sozialen Zielen.
**#2 Nicht nachhaltig** umfasst Investitionen, die nicht als nachhaltige Investitionen gelten.`,
  },
  2: {
    en: `**#1 Aligned with E/S characteristics** includes the investments of the financial product used to attain the environmental or social characteristics promoted by the financial product.
**#2 Other** includes the remaining investments of the financial product which are neither aligned with the environmental or social characteristics, nor are qualified as sustainable investments.

[include the note below where the financial product made sustainable investments]

The category **#1 Aligned with E/S characteristics** covers:
- The sub-category **#1A Sustainable** covers environmentally and socially sustainable investments.
- The sub-category **#1B Other E/S characteristics** covers investments aligned with the environmental or social characteristics that do not qualify as sustainable investments.`,
    de: `**#1 Entspricht E-/S-Merkmalen** umfasst die Investitionen des Finanzprodukts, die zur Erreichung der vom Finanzprodukt geförderten Umwelt- oder Sozialmerkmale dienen.
**#2 Sonstige** umfasst die übrigen Investitionen des Finanzprodukts, die weder mit den Umwelt- oder Sozialmerkmalen übereinstimmen, noch als nachhaltige Investitionen gelten.

[fügen Sie die folgende Anmerkung ein, wenn das Finanzprodukt nachhaltige Investitionen getätigt hat]

Die Kategorie **#1 Entspricht E-/S-Merkmalen** umfasst:
- Die Unterkategorie **#1A Nachhaltig** umfasst ökologisch und sozial nachhaltige Investitionen.
- Die Unterkategorie **#1B Andere E-/S-Merkmale** umfasst Investitionen, die mit den Umwelt- oder Sozialmerkmalen übereinstimmen, aber nicht als nachhaltige Investitionen gelten.`,
  },
  3: {
    en: `The graphs below show in green the percentage of investments that were aligned with the EU Taxonomy. As there is no appropriate methodology to determine the taxonomy-alignment of sovereign bonds, the first graph shows the Taxonomy alignment in relation to all the investments of the financial product including sovereign bonds, while the second graph shows the Taxonomy alignment only in relation to the investments of the financial product other than sovereign bonds.`,
    de: `Die folgenden Grafiken zeigen in Grün den Prozentsatz der Investitionen, die mit der EU-Taxonomie übereinstimmen. Da es keine geeignete Methodik zur Bestimmung der Taxonomie-Konformität von Staatsanleihen gibt, zeigt die erste Grafik die Taxonomie-Konformität in Bezug auf alle Investitionen des Finanzprodukts einschließlich Staatsanleihen, während die zweite Grafik nur die Taxonomie-Konformität in Bezug auf die Investitionen ohne Staatsanleihen darstellt.`,
  },
  4: {
    en: `For the purpose of these graphs, ‘sovereign bonds’ consist of all sovereign exposures`,
    de: `Für die Zwecke dieser Grafiken umfassen „Staatsanleihen“ alle staatlichen Engagements.`,
  },
}
